import microuniversoApi from "app/api/microuniversoApi"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { useAppSelector } from "app/redux/hooks"
import { Parametro } from "app/types/Parametro"
import { tratamentoErroPadrao } from "app/use-cases"
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import React, { useEffect, useRef, useState } from "react"
import { DadosProdutosLote, Lotes } from "../produto-lote/ProdutoLote"
import { ProdutoLoteEditar } from "./ProdutoLoteEditar"

export type ProdutoLoteEditarContainerProps = {
    passos: Dict<string, () => void>,
    onVoltar: () => void,
    dadosProdutoLote: DadosProdutosLote
    lote: Lotes
}

export const ProdutoLoteEditarContainer = (props: ProdutoLoteEditarContainerProps) => {

    const orcamento = useAppSelector((store) => store.orcamento);
    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const [parametros, setParametros] = useState<Parametro[]>([])
    const [parametrosCarregados, setParametrosCarregados] = useState(false)

    const atualizarParametros = async () => {
        setParametros(
            await obterParametros({
                nomes: [
                    "CONTROLE_VALIDADE_PRODUTOS",
                ],
            })
        );
    };

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;


    const onSalvarEdicaoLote = async (lote: Lotes) => {
        try {
            globalMU.blockUI()
            const resposta = await microuniversoApi.Orcamento.reservarLote(orcamento.IdentificadorOrcamento, lote)
            if ("Error" in resposta) {
                return
            }

            if (!("HasError" in resposta)) {
                globalMU.showSuccessMessage("Lote reservado com sucesso");
                onVoltar()
            }

        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }

    const onVoltar = () => {
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        passosInterno.current.get(passo)()
    }

    useEffect(() => {
        atualizarParametros()
        passosInterno.current.set("Editar", () => { })
        setParametrosCarregados(true)
    }, [])


    return (
        <>

            {parametrosCarregados &&
                <>
                    <Breadcrumb2Container
                        passos={passosInterno.current.keysToList()}
                        id="ProdutoLoteEditarContainer"
                        exibirBotaoLimpar={false}
                        exibirBotaoVoltar={true}
                        onBotaoVoltarClicado={onVoltar}
                        onPassoSelecionado={onPassoSelecionado}
                    />

                    <br />

                    <ProdutoLoteEditar
                        dadosProdutoLote={props.dadosProdutoLote}
                        lote={props.lote}
                        controlaValidade={valorParametro("CONTROLE_VALIDADE_PRODUTOS") == "S"}
                        onSalvar={onSalvarEdicaoLote}
                    />

                </>
            }
        </>
    )
} 